export const actions = {
  getTablesInfo({ commit }) {
    const existingTablesInfo = JSON.parse(localStorage.getItem('tablesInfo'));

    if (existingTablesInfo) {
      commit('SET_TABLES', existingTablesInfo);
    } else {
      commit('SET_TABLES', []);
    }
  },
  setTables({ commit }, tables) {
    localStorage.setItem('tablesInfo', JSON.stringify(tables));
    commit('SET_TABLES', tables);
  },
  clearTables({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAR_TABLES');
      resolve();
    });
  },
};
